import * as React from 'react';

// MUI
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import { OptionalDate } from './utility';

export interface DatePickerBaseProps {
  initialValue: OptionalDate;
  onChange: (date: OptionalDate) => void;
}

interface DatePickerProps extends DatePickerBaseProps {
  minDate?: OptionalDate;
  maxDate?: OptionalDate;
  errorMessage?: string;
}

export const DatePicker: React.FC<DatePickerProps> = (props) => {
  const { onChange, minDate, maxDate, errorMessage, initialValue } = props;

  const [state, setState] = React.useState<{ date: OptionalDate; error?: string }>({
    date: initialValue,
  });

  const handleChange = (date: OptionalDate) => {
    if (!date?.isValid()) {
      setState((s) => ({
        ...s,
        date: null,
        error: undefined,
      }));
      onChange(null);
      return;
    }

    const sanitizedDate = date.startOf('day');

    if (sanitizedDate.isAfter(maxDate) || sanitizedDate.isBefore(minDate)) {
      setState((s) => ({
        ...s,
        date: null,
        error: errorMessage || 'Invalid date',
      }));
      onChange(null);
      return;
    }

    setState((s) => ({ ...s, date: sanitizedDate, error: undefined }));
    onChange(sanitizedDate);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DesktopDatePicker
        inputFormat="MM/DD/yyyy"
        minDate={minDate || undefined}
        maxDate={maxDate || undefined}
        value={state.date}
        onChange={handleChange}
        renderInput={(params: TextFieldProps) => (
          <TextField
            {...params}
            inputProps={{
              style: { fontSize: 16 },
              ...params.inputProps,
            }}
            sx={{
              width: 350,
            }}
            helperText={state.error}
            error={!!state.error}
          />
        )}
      />
    </LocalizationProvider>
  );
};
